import { AppRegion, getAppRegion, isApacRegion as checkIsApacRegion } from "../utils/region";

export const useRegion = (): { region: AppRegion; isApacRegion: boolean } => ({
  region: getAppRegion(),
  isApacRegion: checkIsApacRegion(),
});
